import styled from 'styled-components';
import { Icon, Image, Placeholder } from 'semantic-ui-react';
import { colors, layout } from '../../../../config/styles';
import Badge from '../../../../components/Badge';
import { LoadingSpinner } from '../../../../components/Loaders';
import { theme } from '../../../../styles/theme';

export const StyledLoader = styled(LoadingSpinner)`
  &&& {
    margin-top: 20px;
  }
`;

export const CarouselOuterContainer = styled.div`
  height: 532px;
  max-width: 720px;
  margin-right: auto;
  margin-left: auto;
  .carousel-root {
    .carousel.carousel-slider {
      overflow: visible;
      .slide {
        background: transparent;
      }
      .control-arrow {
        padding: 0;
        display: block;
        opacity: 0.6;
        width: 48px;
        height: 48px;
        font-family: Icons;
        font-style: normal;
        font-weight: 400;
        text-decoration: inherit;
        text-align: center;
        speak: none;
        font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        background: transparent !important;
        top: 50%;
        transform: translateY(-50%);
        &:hover {
          &:not(control-disabled) {
            opacity: 1;
          }
        }
        &.control-disabled {
          opacity: 0.2 !important;
        }
        &:before {
          margin: 0;
          display: inline;
          border: none !important;
        }
        &.control-next {
          right: -108px;
          &:before {
            content: '\f105';
          }
        }
        &.control-prev {
          left: -108px;
          &:before {
            content: '\f104';
          }
        }
      }
    }
  }
`;

export const CarouselImageWrapper = styled.div`
  height: 450px;
  border-radius: ${layout.containerBorderRadius}px;
`;

export const CarouselTitleWrapper = styled.div`
  text-align: left;
  margin-bottom: 24px;
`;

export const CarouselDate = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 8px;
`;

export const CarouselTitle = styled.div`
  opacity: 0.6;
  font-size: 16px;
  line-height: normal;
`;

export const ModalCloseIcon = styled(Icon)`
  &&& {
    transition: all 0.25s ease-in;
    width: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 28px;
    position: absolute;
    top: 8px;
    right: 0;
    color: #fff;
    opacity: 0.6 !important;
    padding: 0 !important;
    margin: 0 !important;
    &:hover {
      opacity: 1 !important;
    }
  }
`;

export const StyledPlaceholder = styled(Placeholder)`
  &&& {
    min-width: 720px;
    border-radius: 4px;
  }
`;
export const StyledPlaceholderImage = styled(Placeholder.Image)`
  &&& {
    padding-top: 62.5% !important;
    border-radius: 4px;
  }
`;

export { Image };

export const StyledBadge = styled(Badge)`
  margin-left: 8px;
`;

export const OutcomeDot = styled.span<{ $isAnomaly: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${(props) =>
    props.$isAnomaly ? colors.mainError : theme.colors.secondary600};
`;

export const FailedAnomaly = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${colors.mainError};
`;

export const StyledIconContainer = styled.span``;

export const ScheduleHistoryContainer = styled.div`
  width: 400px;
`;

export const ScheduleHistoryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 56px 78px;
  align-items: center;
`;

export const ScheduleHistoryHeader = styled.div`
  padding-left: 16px;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const ScheduleHistoryHeaderCell = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
`;

export const ScheduleHistoryCell = styled.div<{ $align?: string }>`
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
  ${({ $align }) =>
    $align &&
    `
    text-align: ${$align};
  `}
`;

export const ScheduleHistoryLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  padding: 10px;
  text-align: center;
  font-weight: 500;
`;

export const ScheduleHistoryContent = styled.div`
  max-height: 180px;
  overflow-y: auto;
  padding-left: 16px;
`;

export const ScheduleHistoryRunButtonContainer = styled.div`
  display: flex;
  column-gap: 12px;
  margin-top: 4px;
`;

export const ScheduleHistoryRunButtonPlaceholder = styled.div`
  width: 14px;
`;
